import { IComponentController } from 'angular'
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
//import {IRoute} from '../../../../../core/interfaces/route.interface';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';


interface IPageTf2007 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    foamultiOccurrenceOptions: IMultiOccurrenceOptions;
    fovmultiOccurrenceOptions: IMultiOccurrenceOptions;
}

interface ITf2007Params {
    id: number;
}


/* @ngInject */
export default function Tf2007Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    $stateParams: ITf2007Params,
    Menu: IMenuClass,
    MenuItemAction: IMenuItemActionClass,
    //tf2008Route: IRoute
) {
    const vm: IPageTf2007 = this;

    vm.monoOccurrenceOptions = {
        fonctions: {
            boutonDupliquer: false,
        },
        actionsMore: new Menu([
            new MenuItemAction(
                'LBL_BTN_COP',
                'BOUCOP',
                (data: any) => ({
                    folcleint: vm.monoOccurrence.data.$id
                }),
                {
                    icon: 'content_copy',
                    iconButton: false,
                    fonction: 'BOUCOPIE',
                    successAction: () => {
                        vm.monoOccurrence.fetchData();
                    },
                    formulaireConfirmationAction: {
                        lblTitre: 'LBL_BTN_COP',
                        lblConfirm: 'G_LBL_BTN_ENREGISTRER',
                        largeurFormulaire: 30,
                        formulaire: new Formulaire([
                            new FormulaireItem('folcod'),
                            new FormulaireItem('folann'),
                            new FormulaireItem('folannnew', {
                                required: true
                            })
                        ], { largeurDefaut: 100 })
                    }
                }
            )
        ]),
        formulaire: new Formulaire('LBL_BLC_FOL', [
            new FormulaireItem('folcod', { largeur: 20 }),
            new FormulaireItem('foldsc', { largeur: 46 }),
            new FormulaireItem('folann', { largeur: 33 }),
            new FormulaireItem('vaecodfedpro', { largeur: 33 }),
            new FormulaireItem('folnumappfml', { largeur: 33 }),
            new FormulaireItem('folnumappxml', { largeur: 33 }),
            new FormulaireItem('folimpori', { largeur: 33 }),
            new FormulaireItem('folimpmod', { largeur: 33 }),
            new FormulaireItem('folshexml', { largeur: 33 }),
        ], { largeurDefaut: 66 })
    }

    /* Type de donnees valeur des cases */
    vm.fovmultiOccurrenceOptions = {
        bloc: 'fov',
        fonctions: {
            boutonDupliquer: false
        },
        pagination: {
            nbElementsPossibles: [10, 25, 50],
            nombreElementPage: 10
        },
        colonnesVisibles: [
            { nom: 'fovcod', largeur: 100 },
            { nom: 'fovdsc', largeur: 200 }
        ],
        formulaire: new Formulaire('LBL_BLC_FOV', [
            new FormulaireItem('fovcod', {largeur: 10}),
            new FormulaireItem('fovdsc', {largeur: 40})
        ], { largeurDefaut: 50 })
    };

    /* Type de donnees detail des cases */
    vm.foamultiOccurrenceOptions = {
        bloc: 'foa',
        fonctions: {
            boutonDupliquer: false
        },
        pagination: {
            nbElementsPossibles: [10, 25, 50],
            nombreElementPage: 10
        },
        colonnesVisibles: [
            { nom: 'foacod', largeur: 90 },
            { nom: 'foacodintmai', largeur: 90 },
            { nom: 'foadsc', largeur: 150 },
            { nom: 'vaedscfoatyp', largeur: 90 },
            { nom: 'foavaldef', largeur: 90 },
            { nom: 'foatri', largeur: 90 },
            { nom: 'foaflgsom', largeur: 90 },
            { nom: 'foaflgmntmax', largeur: 90 }
        ],
        formulaire: new Formulaire('LBL_BLC_FOA', [
            new FormulaireItem('foacod'),
            new FormulaireItem('foacleintmai'),
            new FormulaireItem('foadsc'),
            new FormulaireItem('vaefoatyp'),
            new FormulaireItem('foavaldef'),
            new FormulaireItem('foatri'),
            new FormulaireItem('foaflgsom'),
            new FormulaireItem('foaflgmntmax')
        ], { largeurDefaut: 30}),
        multiOccurrenceOptionsEnfant: vm.fovmultiOccurrenceOptions
    };
}
